import type { InputHTMLAttributes } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
  error?: string | null;
};

let counter = 0;
const nextId = () => `f${++counter}`;

export default function Field({ label, hint, error, id, ...rest }: Props) {
  const inputId = id ?? nextId();
  const hasError = Boolean(error);
  return (
    <label
      htmlFor={inputId}
      data-field-error={hasError ? "true" : undefined}
      style={{ display: "block", marginBottom: "1rem" }}
    >
      <div
        className="eyebrow"
        style={{
          color: hasError ? "var(--c-coral)" : "var(--c-palm)",
          fontSize: "0.7rem",
          marginBottom: "0.4rem",
        }}
      >
        {label}
        {hasError && (
          <span aria-hidden="true" style={{ marginLeft: 6 }}>
            *
          </span>
        )}
      </div>
      <input
        id={inputId}
        aria-invalid={hasError || undefined}
        {...rest}
        style={{
          width: "100%",
          padding: "0.85rem 1rem",
          borderRadius: "var(--r-sm)",
          border: hasError
            ? "1.5px solid var(--c-coral)"
            : "1px solid var(--c-rule)",
          background: "#fff",
          color: "var(--c-ink)",
          fontSize: "1rem",
          ...(rest.style ?? {}),
        }}
      />
      {hasError ? (
        <div
          role="alert"
          style={{
            fontSize: "0.8rem",
            color: "var(--c-coral)",
            marginTop: "0.35rem",
            fontWeight: 600,
          }}
        >
          {error}
        </div>
      ) : (
        hint && (
          <div
            style={{
              fontSize: "0.8rem",
              color: "var(--c-palm)",
              opacity: 0.7,
              marginTop: "0.35rem",
            }}
          >
            {hint}
          </div>
        )
      )}
    </label>
  );
}
